import { render, staticRenderFns } from "./ResellerAndCustomerPieChart.vue?vue&type=template&id=34b2169f"
import script from "./ResellerAndCustomerPieChart.vue?vue&type=script&lang=js"
export * from "./ResellerAndCustomerPieChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports